module.exports = __webpack_public_path__ + "files/1bf65025fc1c94c97d28c036455c64d3.svg";